module.exports = __webpack_public_path__ + "static/img/22.ee4a2d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hhwhyx/22.jpg
// module id = 6Fg6
// module chunks = 1